import { Button, ButtonProps } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface ActionButtonProps extends Omit<ButtonProps, 'startIcon'> {
    icon: IconDefinition;
    label: string;
    onClick?: () => void;
}

export function ActionButton({ 
    icon, 
    label, 
    onClick, 
    variant = 'contained',
    color = 'primary',
    ...rest 
}: ActionButtonProps) {
    const handleClick = () => {
        if (onClick) onClick();
    };    return (
        <Button
            className="ticketEasy-module"
            variant={variant}
            color={color}
            startIcon={<FontAwesomeIcon icon={icon} />}
            onClick={handleClick}
            {...rest}
        >
            {label}
        </Button>
    );
}